import styled, { css } from 'styled-components';
import { Picture } from '../../../../picture';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
export const PANEL_EXPERT_MAX_WIDTH_XXS = 80;
export const PANEL_EXPERT_MAX_WIDTH_XS = 120;
/**
 * Panel expert container
 */
export const panelExpertContainerStyles = ({ theme, $position, }) => css `
	display: flex;
	place-self: flex-end;
	margin-left: auto;
	position: relative;
	overflow: hidden;
	width: 100%;
	height: auto;
	aspect-ratio: 3 / 4;
	z-index: 0;
	max-width: ${pxToRem(PANEL_EXPERT_MAX_WIDTH_XXS)};

	::before {
		content: '';
		background-color: ${theme.colors.accent.bgStickerInformative};
		border-radius: ${theme.borderRadius.m}px;
		display: block;
		width: 108%;
		height: 108%;
		z-index: -1;
		position: absolute;
		top: ${pxToRem(theme.spacing['350'])};
		left: auto;
		right: -${pxToRem(theme.spacing['100'])};
		transform: rotate(-21deg);
		transform-origin: top right;
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.xs)}) {
		max-width: ${pxToRem(PANEL_EXPERT_MAX_WIDTH_XS)};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		justify-content: ${$position === 'left' ? 'flex-start' : 'flex-end'};
		margin-left: 0;
		position: relative;
		aspect-ratio: 1 / 1;
		max-width: 100%;

		${$position === 'left' &&
    `
			::before {
				left: -${pxToRem(theme.spacing['400'])};
				right: auto;

				transform: rotate(21deg);
				transform-origin: top left;
			}
		`}

		${$position === 'right' &&
    `
			::before {
				left: -71%;
				right: auto;

				transform: rotate(-69deg);
				transform-origin: top right;
			}
		`}
	}
`;
export const PanelExpertContainer = styled.div `
	${panelExpertContainerStyles}
`;
/**
 * Panel expert picture
 */
export const panelExpertPictureStyles = () => css `
	aspect-ratio: 3 / 4;
`;
export const PanelExpertPicture = styled(Picture) `
	${panelExpertPictureStyles}
`;
/**
 * Panel expert image
 */
export const panelExpertImageStyles = () => css `
	margin: 0;
`;
export const PanelExpertImage = styled(Picture.Image) `
	${panelExpertImageStyles}
`;
